import create from 'zustand';
import { devtools } from 'zustand/middleware';

interface BannerError {
  id: string;
  onRetry?: () => void;
}

interface ErrorBannerState {
  errors: Record<string, BannerError>;
  showError: (id: string, onRetry?: () => void) => void;
  clearError: (id: string) => void;
}

export const useErrorBannerStore = create<ErrorBannerState>(
  devtools(
    (set) => ({
      errors: {},

      showError: (id, onRetry) =>
        set(
          (state) => ({ errors: { ...state.errors, [id]: { id, onRetry } } }),
          false,
          'showError'
        ),

      clearError: (id) =>
        set(
          (state) => {
            const { [id]: _, ...rest } = state.errors;
            return { errors: rest };
          },
          false,
          'clearError'
        ),
    }),
    'Error Banner Store'
  )
);
